// SavvytronWebsite.jsx
import React from 'react';
import HeroSection from '../components/HeroSection';
import AppointmentForm from '../components/AppointmentForm';
import SavvytronHeader from '../components/SavvytronHeader';
// import WhoWeHelpCarousel from '../components/WhoWeHelpCarousel';
import ServicesShowcase from "../components/ServicesShowcase";
import HowItWorksSection from "../components/HowItWorksSection";
import TrustBadges from '../components/TrustBadges';
import TechStackSection from '../components/TechStackSection';
import IntroLogoAnimation from '../components/IntroLogoAnimation';

import { useEffect, useRef } from 'react';
//import { useNavigate } from 'react-router-dom';
import '../index.css'; // Ensure you import your global styles

export default function SavvytronWebsite() {
  //const navigate = useNavigate();
  const headerLogoRef = useRef(null);



  useEffect(() => {
    setTimeout(() => {
      document.body.classList.add("home-loaded");
    }, 2100); // matches the logo animation
  }, []);


  return (
    <>
      <IntroLogoAnimation targetRef={headerLogoRef} />

      <div className="min-h-screen text-gray-800 font-sans bg-white pb-10">
        {/* Logo + title (same component you already had) */}
        <SavvytronHeader ref={headerLogoRef} />

        <div className="max-w-5xl mx-auto  p-6 sm:p-10">

          {/* HERO SECTION - MOBILE FIRST WITH FLOATING UI ANIMATION */}
          < HeroSection />


          {/* WHO WE HELP CAROUSEL */}
          {/* <WhoWeHelpCarousel /> */}

          {/* SERVICES SHOWCASE */}
          <ServicesShowcase />



          {/* HOW IT WORKS – PROCESS SECTION */}
          <HowItWorksSection />

          {/* TRUST BADGES SECTION */}
          <TrustBadges />

          {/* TECH STACK SECTION */}
          <TechStackSection />



          {/* About + appointment form */}
          <section className="grid gap-8 mt-4 sm:grid-cols-2">
            <div className="text-justify">
              <h3 className="text-base font-semibold mb-2">
                Hi, I'm <span className="text-[#785f14]">Dinesh</span> 👋
              </h3>
              <p className="text-gray-600 mb-2">
                I'm a Software Engineer and a developer based in Dallas, TX.
              </p>
              <p className="text-gray-600 mb-2">
                I started SavvyTron to help local businesses make the shift online—easily, affordably,
                and effectively.
              </p>
              <p className="text-gray-600 mb-2">
                As a solo founder and your personal tech expert, I’ll be your dedicated guide through
                every step of your digital journey—and I’ll be here for the long haul.
              </p>
              <p className="text-gray-600">
                Whether you're looking for a new website or tools to simplify your workflow, I'm here
                to help.
              </p>
            </div>

            <AppointmentForm />
          </section>

          {/* Footer */}
          <footer className="flex flex-col gap-4 mt-8 border-t border-gray-200 pt-6 text-sm text-gray-700 md:flex-row md:justify-between">
            <div className='mb-4 md:mb-0'>
              <p><strong>Email:</strong> contact@savvytron.com</p>
              <p><strong>Location:</strong> Based in Dallas, TX – Available remotely or in-person</p>
              <p><strong>Hours:</strong> Mon–Sat, 10 AM to 6 PM</p>
            </div>

            <div className="md:self-center">
              <a
                href="/login"
                className="
                         w-full sm:w-auto
                          inline-flex items-center justify-center
                        px-6 py-2.5
                             rounded-lg
                                    bg-brand/10           /* 10 % tint of brand colour */
                           text-brand
    font-medium
    transition
    hover:bg-brand/20
    active:bg-brand/25
    focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40
    text-sm sm:text-base
  "
              >
                Client&nbsp;login
              </a>

            </div>



          </footer>
        </div>
{/* 

        <h2 className="text-center text-gray-400 font-copperplate text-s">
          Chumma !! 😉
        </h2> */}
      </div>

    </>
  );
}
